import { getRequest, postRequest } from "app/axiosClient";
import {
  equipmentDetailsSuccess,
  getTasksRecords,
  hideUpdateButton,
  clearTasksRecords,
} from "./EquipmentDetailsSlice";
import {
  showLoader,
  hideLoader,
} from "../../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "common/utils/OpenNotificationWithIcon";
export const getEquipmentDetailsAPI = (payload) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(
      `api/Equipment/GetEquipmentDetails?equipmentId=${payload}`,
    )
      .then((res) => {
        dispatch(equipmentDetailsSuccess(res.data));
        dispatch(hideLoader());
        return true;
      })
      .catch((e) => {
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Equipment.AnErrorOccurredWhileFetchingDetails",
        );
        return false;
      });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Equipment.AnErrorOccurredWhileFetchingDetails",
    );
    return false;
  }
};

export const updateLocationAPI = (payload) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Equipment/UpdateEquipmentLocation`, payload)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "EquipmentDetails.LocationUpdatedSuccessfully",
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "EquipmentDetails.LocationUpdateFailed",
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "EquipmentDetails.LocationUpdateFailed",
    );
    return false;
  }
};

export const updateSpecAPI = (payload) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Equipment/UpdateEquipmentSpecs`, payload)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "EquipmentDetails.SpecUpdatedSuccessfully",
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "EquipmentDetails.SpecUpdatedFailed",
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "EquipmentDetails.SpecUpdatedFailed",
    );
    return false;
  }
};

export const getTasksByEquipmentIdApi =
  (appointmentNbr, equipmentId) => (dispatch) => {
    try {
      dispatch(showLoader());
      getRequest(
        `api/Tasks/GetTasksByEquipmentID?appoinmentNbr=${appointmentNbr}&equipmentID=${equipmentId}`,
      )
        .then((res) => {
          dispatch(getTasksRecords(res.data));
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Visits.Unablefetchdata",
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Visits.Unablefetchdata",
      );
    }
  };

export const getTasksFromServiceTemplateByEquipmentIdApi =
  (serviceOrderNumber, equipmentId) => (dispatch) => {
    var payload = {
      serviceOrderNumber: serviceOrderNumber,
      equipmentID: equipmentId,
    };
    try {
      dispatch(showLoader());
      postRequest(`api/Tasks/ServiceTaskList`, payload)
        .then((res) => {
          dispatch(getTasksRecords(res.data));
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Visits.Unablefetchdata",
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Visits.Unablefetchdata",
      );
    }
  };

export const updateServiceTemplateTaskApi =
  (input, appointmentNbr, equipmentId) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(`api/Tasks/MarkServiceOrderTemplateCompleted`, input)
        .then((res) => {
          dispatch(hideLoader());
          dispatch(hideUpdateButton());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "EquipmentDetails.Taskupdatedsuccessfully",
          );
          return res;
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Visits.Unableupdatetask",
          );
          throw e;
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Visits.Unableupdatetask",
      );
    }
  };

export const updateTaskStatusApi = (input, equipmentId) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Tasks/UpdateTasksStatus`, input)
      .then((res) => {
        dispatch(hideLoader());
        dispatch(hideUpdateButton());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "EquipmentDetails.Taskupdatedsuccessfully",
        );
        return res;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Visits.Unableupdatetask",
        );
        throw e;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Visits.Unableupdatetask",
    );
  }
};

export const clearTaskRecordsStateApi = () => (dispatch) => {
  dispatch(clearTasksRecords());
};
